<div  class="jackpot-badge">
  {{ amount | currencyFormat:currency }}{{ currencySymbol }}
</div>
